import React from 'react';
import PropTypes from 'prop-types';
import Styles from "../../css";

const style = Styles.combineStyles(
    Styles.fonts.commonFont,
    Styles.button
);
const disabledStyle = Styles.combineStyles(
    style,
    Styles.disabledButton
);

const Button = (props) => {
    // React 19 doesn't apply defaultProps automatically, so we need to handle defaults explicitly
    const {
        isDisabled = false,
        isWide = false,
        useBootstrapWidthClasses = true,
        addMarginTop = true,
        onClick,
        children
    } = props;

    let runtimeStyle = style;
    // disable if needed
    if (isDisabled)
        runtimeStyle = disabledStyle;

    if(isWide)
        runtimeStyle = Styles.combineStyles(
            runtimeStyle,
            {width: "100%"}
        );

    if(!addMarginTop)
        runtimeStyle = Styles.combineStyles(
            runtimeStyle,
            {marginTop: "0px"}
        );

    return (
        <div className="row">
            {/* The div below is for offset, as built in offset in bootstrap refuses to work -_- */}
            {
                useBootstrapWidthClasses &&
                <div className="col-xs-3 col-md-5"></div>
            }
            <button className={isWide || !useBootstrapWidthClasses ? "" : "col-xs-6 col-md-2"}
                    style={ runtimeStyle } onClick={onClick}>
                { children }
            </button>
        </div>
    );
}


Button.propTypes = {
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    isWide: PropTypes.bool,
    useBootstrapWidthClasses: PropTypes.bool,
    addMarginTop: PropTypes.bool,
}

Button.defaultProps = {
    isDisabled: false,
    isWide: false,
    useBootstrapWidthClasses: true,
    addMarginTop: true
}

export default Button;
